import React from 'react';

function MakeVisible({children}){
    return <></>;
}

export default MakeVisible;